define.alias("shared/components/shared/wizard/slide-count", "calendar/components/shared/wizard/slide-count");